var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.5 29.9984H32M25.25 5.24839C25.8467 4.65165 26.6561 4.31641 27.5 4.31641C27.9179 4.31641 28.3316 4.39871 28.7177 4.55862C29.1037 4.71853 29.4545 4.95291 29.75 5.24839C30.0455 5.54386 30.2799 5.89464 30.4398 6.2807C30.5997 6.66675 30.682 7.08052 30.682 7.49839C30.682 7.91625 30.5997 8.33002 30.4398 8.71608C30.2799 9.10213 30.0455 9.45291 29.75 9.74839L11 28.4984L5 29.9984L6.5 23.9984L25.25 5.24839Z",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3);
export default __webpack_public_path__ + "static/media/edit-3.4c3de40531bbb89dd41b2b126958aa86.svg";
export { ForwardRef as ReactComponent };